<div fxLayout="column" fxLayoutGap="20px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
    <form #formCadastro="ngForm">
        <div fxLayout="row" fxLayoutGap="20px" fxFlexFill>
            <div fxLayout="column" fxFlex="100%">
                <mat-toolbar class="titulopartes">Turma</mat-toolbar>
                <div fxFlex="100%" fxLayoutGap="20px" style="padding-top: 15px;">
                    <mat-form-field style="width: 100%;">
                        <mat-label>Turma</mat-label>
                        <mat-select [(ngModel)]="turma.id" name="turma"
                                    required>
                            <mat-option></mat-option>
                            <mat-option *ngFor="let i of getTurmasDisponiveis()" [value]="i.id">
                                {{ getDadosTurma(i) }}
                            </mat-option>
                        </mat-select>
                        <mat-hint *ngIf="getTurmasDisponiveis()?.length === 0 && turmas?.length > 0" align="start">
                            Todas as turmas disponíveis já foram adicionadas
                        </mat-hint>
                        <mat-hint *ngIf="turmas?.length === 0" align="start">Nenhuma turma cadastrada</mat-hint>
                    </mat-form-field>
                    <mat-form-field style="margin: 0 0 0 20px" fxFlex="15%">
                        <input matInput
                               name="dataInicio"
                               [matDatepicker]="dataInicio"
                               (input)="onMascaraDataInput($event)"
                               placeholder="Data início matricula"
                               [(ngModel)]="dataInicioMatricula" required>
                        <mat-datepicker-toggle matSuffix [for]="dataInicio"></mat-datepicker-toggle>
                        <mat-datepicker #dataInicio></mat-datepicker>
                    </mat-form-field>
                    <button type="button" matTooltip="Adicionar nova turma" mat-fab color="primary" (click)="adicionarTurma()"
                            [disabled]="formCadastro.invalid || getTurmasDisponiveis()?.length === 0">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>
        </div>
        <div fxFlex="100%" fxLayoutGap="20px" ngModelGroup="grupoTurmasOficinas" class="grupo">
            <div *ngFor="let matricula of matriculas; let index = index">
                <mat-card appearance="outlined" class="bordas">
                    <mat-toolbar class="titulopartes">{{ index + 1 }} - Turma</mat-toolbar>
                    <div fxLayout="row">
                        <mat-form-field fxFlex fxFlexOffset="20px">
                            <input matInput
                                   value="{{matricula.turma.descricao}}" disabled placeholder="Turma">
                        </mat-form-field>

                        <mat-form-field fxFlex="15" style="margin: 0 0 0 20px">
                            <input matInput
                                   [value]="getDescricaoTurno(matricula.turma.turno)" disabled placeholder="Turno">
                        </mat-form-field>

                        <mat-form-field fxFlex="15" style="margin: 0 0 0 20px">
                            <input matInput name="dataInicio_{{pinDataInicio}}" (input)="onMascaraDataInput($event)"
                                   [matDatepicker]="dataInicio" placeholder="Data início matricula" disabled
                                   [(ngModel)]="matricula.dataInicio"
                                   required>
                            <mat-datepicker-toggle matSuffix [for]="dataInicio"></mat-datepicker-toggle>
                            <mat-datepicker #dataInicio></mat-datepicker>
                        </mat-form-field>

                        <button mat-button
                                (click)="removerTurma(index)"
                                matTooltip="Remover turma e todas suas oficinas"
                                fxFlex="5">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>
                    <mat-card appearance="outlined" class="bordas" style="margin-bottom: 15px">
                        <mat-toolbar class="titulopartes">Oficinas</mat-toolbar>

                        <!-- Seção para adicionar novas oficinas -->
                        <div class="secao-adicionar-oficina" fxLayout="row" fxLayoutGap="20px" fxFlexFill>
                            <mat-form-field fxFlex fxFlexOffset="20px">
                                <mat-label>Oficina...</mat-label>
                                <mat-select [(ngModel)]="oficinaSelecionada[index]" name="oficina_{{index}}"
                                            [disabled]="getOficinasDisponiveis(index)?.length === 0">
                                    <mat-option></mat-option>
                                    <mat-option *ngFor="let oficina of getOficinasDisponiveis(index)" [value]="oficina">
                                        {{ oficina.descricao }}
                                    </mat-option>
                                </mat-select>
                                <mat-hint *ngIf="getOficinasDisponiveis(index)?.length === 0 && matricula.oficinas?.length > 0"
                                          align="start">
                                    Todas as oficinas da turma já foram adicionadas
                                </mat-hint>
                                <mat-hint *ngIf="getOficinasDisponiveis(index)?.length === 0 && matricula.oficinas?.length === 0"
                                          align="start">
                                    Não há oficinas disponíveis para esta turma
                                </mat-hint>
                            </mat-form-field>
                            <button mat-fab color="primary"
                                    (click)="adicionarOficina(index, oficinaSelecionada[index])"
                                    [disabled]="!oficinaSelecionada[index] || getOficinasDisponiveis(index)?.length === 0" type="button"
                            >
                                <mat-icon>add</mat-icon>
                            </button>
                        </div>

                        <!-- Lista de oficinas já adicionadas -->
                        <div fxLayout="row" fxLayoutGap="20px" fxFlexFill
                             *ngFor="let item of matricula.oficinas; let index2 = index">
                            <mat-form-field fxFlex fxFlexOffset="20px">
                                <input matInput [ngModelOptions]="{standalone: true}" maxlength="45"
                                       [(ngModel)]="item.atividade.descricao" disabled placeholder="Oficina">
                            </mat-form-field>
                            <mat-form-field style="margin: 0 0 0 20px" fxFlex="15">
                                <input matInput name="dataInicio_{{pinDataInicio}}" (input)="onMascaraDataInput($event)"
                                       [matDatepicker]="dataInicioAtividade" placeholder="Data Início" disabled
                                       [(ngModel)]="item.dataInicioAtividade"
                                       required>
                                <mat-datepicker-toggle matSuffix [for]="dataInicioAtividade"></mat-datepicker-toggle>
                                <mat-datepicker #dataInicioAtividade></mat-datepicker>
                            </mat-form-field>
                            <button type="button" mat-button (click)="deletar(item, index, index2)" fxFlex="5">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                    </mat-card>
                </mat-card>
            </div>

        </div>
    </form>
</div>

